module.exports = __webpack_public_path__ + "img/dsci0086.ed51f3b1.jpg";